import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines } from "./Reveal";

export const PageHero = ({ image, eyebrow, lines, lede, children, tall = false }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 160]);
  return (
    <section className={tall ? "page-hero tall" : "page-hero"} ref={ref} data-testid="page-hero">
      <motion.div className="page-hero-image" style={{ y, backgroundImage: `url('${image}')` }} />
      <div className="page-hero-overlay" />
      <div className="page-hero-content">
        <motion.span
          className="eyebrow light"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          {eyebrow}
        </motion.span>
        <MaskedLines lines={lines} />
        {lede && (
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.65, ease: [0.22, 1, 0.36, 1] }}
          >
            {lede}
          </motion.p>
        )}
        {children}
      </div>
    </section>
  );
};
